// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { Modal } from "antd";
import { ViewProfileImage } from "./viewProfileImage";
import { UploadProfileImage } from "./uploadProfileImage";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
export function ProfileImageModal(props) {
  const { visible, onCancel, action, width, height, agentId, url, retrieveUser, title } = props;
  const modalTitle = action === "edit" ? "Update Profile Picture" : "Profile Picture";

  return (
    <Modal visible={visible} title={title || modalTitle} onCancel={onCancel} footer={null}>
      {action === "view" && <ViewProfileImage url={url} width={width} height={height} />}
      {action === "edit" && (
        <UploadProfileImage agentId={agentId} closeModal={onCancel} retrieveUser={retrieveUser} />
      )}
    </Modal>
  );
}
